import { render, staticRenderFns } from "./company-detail.component.html?vue&type=template&id=f25d48dc&scoped=true&external"
import script from "./company-detail.component.ts?vue&type=script&lang=ts&external"
export * from "./company-detail.component.ts?vue&type=script&lang=ts&external"
import style0 from "./company-detail.component.scss?vue&type=style&index=0&id=f25d48dc&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f25d48dc",
  null
  
)

export default component.exports